export { default } from './SharesSlider';
